import { createContext } from 'react';
import {
    QUERY_KEYS_IGD,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const ConditionalityChartsDataContext = createContext();

const ConditionalityChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();
    
    const filterParams = {
        year: filters.year?.value || '',
        month: filters.month?.value || '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_IGD.FAMILY_BREACHS_OF_CONDITIONS,
            url: 'governanceroom/socialdashboard/igd/values/familiesBreachOfConditions',
        },
        filterParams
    );

    const childrenSchoolAttendanceComparisonData = useChartsData(
        {
            key: QUERY_KEYS_IGD.CHILDREN_SCHOOL_ATTENDANCE_COMPARISON,
            url: 'governanceroom/socialdashboard/igd/values/childrenSchoolAttendanceComparison',
        },
        filterParams
    );

    const childrenSchoolAttendanceComparisonPercentageData = useChartsData(
        {
            key: QUERY_KEYS_IGD.CHILDREN_SCHOOL_ATTENDANCE_COMPARISON_PERCENTAGE,
            url: 'governanceroom/socialdashboard/igd/values/childrenSchoolAttendanceComparisonPercentage',
        },
        filterParams
    );

    const withInformedHealthConditionsComparisonData = useChartsData(
        {
            key: QUERY_KEYS_IGD.WITH_INFORMED_HEALTH_CONDITIONS_COMPARISON,
            url: 'governanceroom/socialdashboard/igd/values/withInformedHealthConditionsComparison',
        },
        filterParams
    );

    const withInformedHealthConditionsComparisonPercentageData = useChartsData(
        {
            key: QUERY_KEYS_IGD.WITH_INFORMED_HEALTH_CONDITIONS_COMPARISON_PERCENTAGE,
            url: 'governanceroom/socialdashboard/igd/values/withInformedHealthConditionsComparisonPercentage',
        },
        filterParams
    );

    const profileCadUnicoComparisonData = useChartsData(
        {
            key: QUERY_KEYS_IGD.PROFILE_CAD_UNICO_COMPARISON,
            url: 'governanceroom/socialdashboard/igd/values/profileCadUnicoComparison',
        },
        filterParams
    );

    const profileCadUnicoComparisonPercentageData = useChartsData(
        {
            key: QUERY_KEYS_IGD.PROFILE_CAD_UNICO_COMPARISON_PERCENTAGE,
            url: 'governanceroom/socialdashboard/igd/values/profileCadUnicoComparisonPercentage',
        },
        filterParams
    );

    const chartData = {
        familyBreachsOfConditionsAnual: data?.anualEvolution ?? [],
        familyBreachsOfConditionsMonth: data?.monthEvolution ?? [],
        childrenSchoolAttendanceComparisonAnual: childrenSchoolAttendanceComparisonData?.data?.anualEvolution ?? [],
        childrenSchoolAttendanceComparisonMonth: childrenSchoolAttendanceComparisonData?.data?.monthEvolution ?? [],
        childrenSchoolAttendanceComparisonPercentageAnual: childrenSchoolAttendanceComparisonPercentageData?.data?.anualEvolution ?? [],
        childrenSchoolAttendanceComparisonPercentageMonth: childrenSchoolAttendanceComparisonPercentageData?.data?.monthEvolution ?? [],
        withInformedHealthConditionsComparisonAnual: withInformedHealthConditionsComparisonData?.data?.anualEvolution ?? [],
        withInformedHealthConditionsComparisonMonth: withInformedHealthConditionsComparisonData?.data?.monthEvolution ?? [],
        withInformedHealthConditionsComparisonPercentageAnual: withInformedHealthConditionsComparisonPercentageData?.data?.anualEvolution ?? [],
        withInformedHealthConditionsComparisonPercentageMonth: withInformedHealthConditionsComparisonPercentageData?.data?.monthEvolution ?? [],
        profileCadUnicoComparisonAnual: profileCadUnicoComparisonData?.data?.anualEvolution ?? [],
        profileCadUnicoComparisonMonth: profileCadUnicoComparisonData?.data?.monthEvolution ?? [],
        profileCadUnicoComparisonPercentageAnual: profileCadUnicoComparisonPercentageData?.data?.anualEvolution ?? [],
        profileCadUnicoComparisonPercentageMonth: profileCadUnicoComparisonPercentageData?.data?.monthEvolution ?? [],
    };

    return (
        <ConditionalityChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ConditionalityChartsDataContext.Provider>
    );
};

export default ConditionalityChartsDataProvider;
